module.exports = __webpack_public_path__ + "img/Brand_learning_one.f54dc93e.png";